import * as Serialize from "./serialize";
var StringParam = {
  encode: Serialize.encodeString,
  decode: Serialize.decodeString
};
var createEnumParam = function createEnumParam(enumValues) {
  return {
    encode: Serialize.encodeString,
    decode: function decode(input) {
      return Serialize.decodeEnum(input, enumValues);
    }
  };
};
var createEnumArrayParam = function createEnumArrayParam(enumValues) {
  return {
    encode: function encode(text) {
      return Serialize.encodeArray(text == null || Array.isArray(text) ? text : [text]);
    },
    decode: function decode(input) {
      return Serialize.decodeArrayEnum(input, enumValues);
    }
  };
};
var createEnumDelimitedArrayParam = function createEnumDelimitedArrayParam(enumValues) {
  var entrySeparator = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : "_";
  return {
    encode: function encode(text) {
      return Serialize.encodeDelimitedArray(text == null || Array.isArray(text) ? text : [text], entrySeparator);
    },
    decode: function decode(input) {
      return Serialize.decodeDelimitedArrayEnum(input, enumValues, entrySeparator);
    }
  };
};
var NumberParam = {
  encode: Serialize.encodeNumber,
  decode: Serialize.decodeNumber
};
var ObjectParam = {
  encode: Serialize.encodeObject,
  decode: Serialize.decodeObject
};
var ArrayParam = {
  encode: Serialize.encodeArray,
  decode: Serialize.decodeArray
};
var NumericArrayParam = {
  encode: Serialize.encodeNumericArray,
  decode: Serialize.decodeNumericArray
};
var JsonParam = {
  encode: Serialize.encodeJson,
  decode: Serialize.decodeJson
};
var DateParam = {
  encode: Serialize.encodeDate,
  decode: Serialize.decodeDate,
  equals: function equals(valueA, valueB) {
    if (valueA === valueB) return true;
    if (valueA == null || valueB == null) return valueA === valueB;
    return valueA.getFullYear() === valueB.getFullYear() && valueA.getMonth() === valueB.getMonth() && valueA.getDate() === valueB.getDate();
  }
};
var DateTimeParam = {
  encode: Serialize.encodeDateTime,
  decode: Serialize.decodeDateTime,
  equals: function equals(valueA, valueB) {
    if (valueA === valueB) return true;
    if (valueA == null || valueB == null) return valueA === valueB;
    return valueA.valueOf() === valueB.valueOf();
  }
};
var BooleanParam = {
  encode: Serialize.encodeBoolean,
  decode: Serialize.decodeBoolean
};
var NumericObjectParam = {
  encode: Serialize.encodeNumericObject,
  decode: Serialize.decodeNumericObject
};
var DelimitedArrayParam = {
  encode: Serialize.encodeDelimitedArray,
  decode: Serialize.decodeDelimitedArray
};
var DelimitedNumericArrayParam = {
  encode: Serialize.encodeDelimitedNumericArray,
  decode: Serialize.decodeDelimitedNumericArray
};
export { ArrayParam, BooleanParam, DateParam, DateTimeParam, DelimitedArrayParam, DelimitedNumericArrayParam, JsonParam, NumberParam, NumericArrayParam, NumericObjectParam, ObjectParam, StringParam, createEnumArrayParam, createEnumDelimitedArrayParam, createEnumParam };